// let uniqueBundleId = 0;

const bundleManager = (function() {

    const getUniqueBundleId = function() {
        // replace with UUID
        
        return [...Array(30)].map(() => Math.random().toString(36)[2]).join('')

        //return uniqueBundleId++;

    }


    const addBundleToCart = function(items) {

        console.log('addBundleToCart', items)

        bundleId = getUniqueBundleId()

        items = items.map(lineItem => {
            lineItem.properties._bundle_uid = bundleId   
            return lineItem
        })

        theoremCart.addItem({
            items
        })
        .then(response => {
            if(!response.status) {
                // SUCCESS
                theoremCart.getCart()
            } else {
                // ERROR
                // document.dispatchEvent(new CustomEvent('bundleError', { 
                //     detail: {
                //         id: bundleId,
                //         data: [response]
                //     } 
                // }))
                console.log('undoing cart addition')
                
                updateBundleQuantity(bundleId, 0).then(() => {
                    document.dispatchEvent(new CustomEvent('bundleError', { 
                        detail: {
                            id: bundleId,
                            data: [response]
                        } 
                    }))
                })
                
            }
        })
    }


    // const undoCartAddition = async function(uniqueBundleId) {

    //     return await theoremCart.getCart()
    //         .then(response => {
    //             
    //         })

    // }

    const updateBundleQuantity = async function(bundleId, quantity) {

        console.log('Updating bundle ' + bundleId + ' quantity to ' + quantity)

        return await theoremCart.getCart()
            .then(response => {

                if(quantity == 0) {

                    const itemsToRemove = response
                        .items
                        .filter(item => item.properties?._bundle_uid == bundleId)
                        .reduce((accumulator, value) => { return { ...accumulator, [value.key]: 0 }}, {})

                    return theoremCart.updateItems(itemsToRemove)
                        .then(() => { console.log('All items removed'); return theoremCart.getCart() })

                } else {

                    const itemsToUpdate = response.items
                        .filter(item => item.properties?._bundle_uid == bundleId)

                    const originalQuantities = itemsToUpdate
                        .reduce((accumulator, value) => { return { ...accumulator, [value.key]: value.quantity }}, {})

                    const newQuantities = itemsToUpdate
                        .reduce((accumulator, value) => { return { ...accumulator, [value.key]: quantity }}, {})

                    return updateLineItemsQuantityRecursive(Object.entries(newQuantities))
                        .then(() => { console.log('All updates completed.'); return theoremCart.getCart() })
                        .catch((exception) => { console.log('Reverting stock to ', originalQuantities); theoremCart.updateItems(originalQuantities); throw exception }) 

                }
            })

    }

    const updateLineItemsQuantityRecursive = async function(lineItems) {

        const [id, quantity] = lineItems.pop()
        console.log('Updating ' + id + ' to quantity: ' + quantity)
        return await theoremCart.changeItem({ id, quantity })
            .then(response => {
                if(!response.status) {
                    if(lineItems.length == 0) {
                        return true
                    }
                    return updateLineItemsQuantityRecursive(lineItems)
                } else {
                    throw response.message
                }
            })
    }



    return {
        getUniqueBundleId,
        addBundleToCart,
        // undoCartAddition,
        updateBundleQuantity,
    }
})()


window.bundleManager = bundleManager